<template>
  <div 
    class="knd-person ">
    <div 
      class="knd-person--inner hover-animation"
      :class="{'has-visited': rol.visited}"
    >
      <div class="knd-person--name">
        {{rol.name}}
      </div>

      <div 
        class="knd-person--header "
        :id="rol.title.replace(' ', '-').toLowerCase()"
      >
        <img ref="avatar" class="avatar" :src="ASSETS + '' + rol.avatar.data.attributes.formats.thumbnail.url" />
        <!-- <img class="play-avatar" src="@/assets/play-btn.png" /> -->
      </div>

      <div>
        <div class="knd-person--title">
          {{rol.title}}
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import { useStore } from 'vuex'
import { ref, onMounted } from 'vue';

export default {
  props: ['rol'],
  setup () {
    const ASSETS = ref(process.env.VUE_APP_ASSETS);

    return {
      ASSETS
    }
  }
}
</script>


<style lang="scss">
  .knd-person {
    // margin: 4em;
    text-align: center;
    opacity: 1;
    z-index:100;
    padding: 0.5em 0;

    transition: opacity .2s ease-in;
    cursor: pointer;

    .knd-person--inner {
      z-index: 10;
      display: flex;
      align-items: center;
    }

    &:hover {
      opacity: 1;
    }

    .knd-person--header {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      margin: 0 1em 0;
      position: relative;

      .avatar {        
        border: 1px solid #FFF;
        border-radius: 50%;
        // box-shadow: 0px 1px 3px 1px #ecebde;
        animation: 3s infinite alternate glow;
      }

      .play-avatar {
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-55%);
      }
    }

    .has-visited {
      .knd-person--title {
        opacity: .5;
      }

      .knd-person--header .avatar {
        animation: none;
      }
    }

    .knd-person--name {
      font-family: $font-header;
      color: #00D9AD;
      font-size: 2.2rem;
    }

    .knd-person--title{
      font-family: $font-header;
      font-family: $font-header;
      font-size: 2.2rem;

      transition: color .2s ease-in;
    }
  }

  .is-top {
    .knd-person--title{
      color: #28006D;
    }
  }

  @keyframes glow {
  from {
    box-shadow: 0px 1px 1px 1px #ecebde;
  }
  to {
    box-shadow: 0px 1px 8px 1px #ecebde;
  }
}
</style>